import { PASTEL_COLORS } from './helpers';

export const colorsPalette = [
  '#00B48A',
  '#7c3aed',
  '#2563eb',
  '#f59e0b',
  '#ef4444',
  'oklch(68.49% 0.1354 170.1)',
  '#0ea5e9',
  '#22c55e',
  '#8b5cf6',
  '#16B394',
  '#1F4E79',
  '#2F6FED',
  '#0F6E78',
  '#6E9F87',
  '#2E6650',
  '#C86A42',
  '#C89B2D',
  '#8A2E3B',
  '#6C4FA3',
  '#3F434A',
  '#69727D',
  '#21c294',
  '#009f7f',
  '#254441',
  '#fc7059',
  '#f9594c',
  '#eb337d',
  '#571426',
  '#000000',
  ...PASTEL_COLORS,
] as const;
